import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import AdminBar from "components/Masterbar/AdminBar";
import { editSupplier, getSupplierById, selectSupplier, selectSuppliersStatus } from "redux/slices/supplierSlice";
import { useParams } from "react-router-dom";
import SupplierForm from "components/Suppliers/form";
import { getAllSupplierGroups, selectSupplierGroups } from "redux/slices/supplierGroupsSlice";

const currentAction = "EDIT";
const EditSupplier = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectSuppliersStatus);
  const supplier = useSelector(selectSupplier);
  const supplierGroups = useSelector(selectSupplierGroups);
  const { id } = useParams();

  useEffect(() => {
    if (id && !loading) {
      dispatch(getSupplierById(id));
    }
  }, [dispatch, id]);
  useEffect(() => {
    if (!supplierGroups.length && !loading) {
      dispatch(getAllSupplierGroups());
    }
  }, [dispatch, supplierGroups]);
  const onSubmit = async (payload) => {
    await dispatch(editSupplier(id, payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.suppliers) : ""
    );
  };

  return (
    <>
      <Navbar />
      <AdminBar />
      <LightLayout doublebar loading={loading || !supplier}>
        <SupplierForm
          action={currentAction}
          initialValues={supplier}
          onSubmit={onSubmit}
          supplierGroups={supplierGroups}
        />
      </LightLayout>
    </>
  );
};

export default EditSupplier;
